import React from 'react';
import { InputAdornment } from '@mui/material';
import { Clear } from '@mui/icons-material';
import { Space } from 'styles/themeSpaces';

export interface ClearAdornmentProps {
  onClear: () => void;
  position?: 'start' | 'end';
  size?: 'small' | 'large';
  show?: boolean;
};

const ClearAdornment = ({
  onClear,
  position = 'end',
  size = 'small',
  show = true
}: ClearAdornmentProps) => {
  return show 
    ? (
        <InputAdornment 
          position={position}
          style={{ cursor: 'pointer', marginRight: Space.spBase }}
        >
          <Clear 
            fontSize={size}
            onClick={onClear} 
          />
      </InputAdornment>
      )
    : null;
};

export default ClearAdornment;
